<template>
 <form id="schritt4form" novalidate>
    <div class="my-4"> 
        <div class="bgTR px-4 px-lg-5 py-4 py-lg-5 justify-content-">
            <div class="schritt-zaehler-position">
                <SchritteZaehler class="w-100"></SchritteZaehler>
            </div>
            <h3 class="pb-3 w-100 text-start">Abschluss des Vertrages</h3>    

            <div class="boxTR px-4 px-lg-5 py-3 py-lg-4 w-100 font-base-links">
                <div class="my-4">
                    <div class="form-group">
                        <div class="form-check form-check-inline mb-3">
                            <input class="form-check-input" type="checkbox" id="ewe4" name="ewe4" v-model="store.kenntnisnahme">
                            <label class="form-check-label" for="ewe4">
                            Ich bestätige die Kenntnisnahme des gewählten Leistungsumfanges: *
                            </label>
                        </div>
                    </div>
                    <div v-if="store.hatZVS()" class="mb-5">
                        <h1 class="font-base-links"><b><span v-html="mainStore.produktName"></span></b> Zahnvorsorge Basis:</h1>
                        <div class="ms-3 ms-md-5">
                            <div class="mt-3">Ich habe zur Kenntnis genommen, dass</div>
                            <ul class="ms-3 ms-md-5">
                                <li class="mt-3">für Versicherungsfälle, die vor Beginn des Versicherungsschutzes eingetreten sind, nicht geleistet wird. Dazu zählen alle Maßnahmen, die zum Zeitpunkt des Vertragsschlusses stattfinden, notwendig,  geplant oder (zahn)ärztlich angeraten sind (Ausnahmen: Prophylaxe  einschließlich der professionellen Zahnreinigung) und</li>
                                <li class="mt-3">innerhalb der ersten drei Versicherungsjahre folgende Leistungshöhen vereinbart sind:
                                    <ul class="ms-3 ms-md-5">
                                        <li>im ersten Versicherungsjahr bis zu 150 EUR</li>
                                        <li>in den ersten beiden Versicherungsjahren höchstens 300 EUR</li>
                                        <li>in den ersten drei Versicherungsjahren höchstens 500 EUR</li>
                                        <li>Diese Staffel entfällt bei Unfall</li>
                                    </ul>
                                    
                                </li>
                            </ul>
                        </div>
                    </div>
                    
                    <div v-if="store.hatZVP()" class="mb-5">
                        <h1 class="font-base-links"><b><span v-html="mainStore.produktName"></span></b> Zahnvorsorge Premium:</h1>
                        <div class="ms-3 ms-md-5">
                            <div class="mt-3">Ich habe zur Kenntnis genommen, dass</div>
                            <ul class="ms-3 ms-md-5">
                                <li class="mt-3">für Versicherungsfälle,  die vor Beginn des Versicherungsschutzes eingetreten sind, nicht  geleistet wird. Dazu zählen alle Maßnahmen, die zum Zeitpunkt des  Vertragsschlusses stattfinden, notwendig, geplant oder (zahn)ärztlich  bzw. kieferorthopädisch angeraten sind (Ausnahmen: Prophylaxe  einschließlich der professionellen Zahnreinigung) und Unfall.</li>
                                <li class="mt-3">innerhalb der ersten drei Versicherungsjahre folgende Leistungshöhen vereinbart sind:
                                    <ul class="ms-3 ms-md-5">
                                        <li>im ersten Versicherungsjahr höchstens 250 Euro</li>
                                        <li>im zweiten Versicherungsjahr höchstens 500 Euro</li>
                                        <li>im dritten Versicherungsjahr höchstens 750 Euro</li>
                                        <li>Diese Staffel entfällt bei Unfall und gilt nicht für Prophylaxe und professionelle Zahnreinigung</li>
                                    </ul>
                                    
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div v-if="store.hatZX2()" class="mb-5">
                        <h1 class="font-base-links"><b><span v-html="mainStore.produktName"></span></b> Zahnersatz x2:</h1>
                        <div class="ms-3 ms-md-5">
                            <div class="mt-3">Ich habe zur Kenntnis genommen, dass</div>
                            <ul class="ms-3 ms-md-5">
                                <li class="mt-3">eine Wartezeit von 6 Monaten gilt,</li>
                                <li class="mt-3">für Versicherungsfälle, für die vor Abschluss des Versicherungsvertrages oder vor Ablauf der Wartezeit ein Heil- und Kostenplan erstellt wurde, kein Versicherungsschutz besteht und</li>
                                <li class="mt-3">innerhalb der ersten drei Versicherungsjahre folgende Leistungshöhen vereinbart sind:
                                    <ul class="ms-3 ms-md-5">
                                            <li>im ersten Versicherungsjahr höchstens 250 Euro</li>
                                            <li>im zweiten Versicherungsjahr höchstens 500 Euro</li>
                                            <li>im dritten Versicherungsjahr höchstens 750 Euro</li>
                                            <li>Diese Staffel entfällt bei Unfall</li>
                                        </ul>
                                    
                                    
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div v-if="store.hatStationaer()">
                        <h1 class="font-base-links"><b><span v-html="mainStore.produktName"></span></b> Ein-/Zweibettzimmer:</h1>
                        <div class="ms-5">
                            <div class="mt-3">Ich habe zur Kenntnis genommen, dass</div>
                            <ul class="ms-3 ms-md-5">
                                <li class="mt-3">eine allgemeine Wartezeit von 3 Monaten (entfällt bei Unfall) bzw. für Entbindung, Psychotherapie und Zahnersatz eine Wartezeit von 8 Monaten gilt,</li>
                                <li class="mt-3">die Vergangenheitsklausel für die gesamte Laufzeit des Vertrages gilt. Bedeutung der Klausel:</li>
                            </ul>
                            <div class="ms-3 ms-md-5">
                                Für Versicherungsfälle, die vor Abschluss des Versicherungsvertrages eingetreten sind, leisten wir nicht.<br>
                                Was bedeutet das?</div>
                            <div class="ms-3 ms-md-5">
                                Krankheiten, die in den letzten 2 Jahren vor Versicherungsbeginn bestanden und für die eine stationäre Behandlung in dieser Zeit bereits eine Behandlungsoption darstellte, werden vom Versicherungsschutz nicht erfasst. Alle anderen Krankenhausaufenthalte sind versichert.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            

            <div class="boxTR mt-4 px-4 px-lg-5 py-3 py-lg-4 w-100 font-base-links">
                <h1 class="font-lg-links-bold mb-3">Einwilligungserklärungen</h1>
                <b>Einwilligungserklärung in die Datenverarbeitung (auch durch Dritte) und weitere Erklärungen *</b>
                <div class="form-group">
                    <div class="form-check form-check-inline mb-3 mt-3">
                        <input class="form-check-input" type="checkbox" id="ewe1" name="ewe1" v-model="store.eweSozialdaten">
                        <label class="form-check-label" for="ewe1">
                        {{ ewe1LabelText }}
                        </label>
                    </div>
                </div>
            </div>

            <div class="v4y-einwilligung-box mt-4 w-100">
                <div class="mx-4 py-3">
                    <div class="pb-3">
                        <b>Einwilligungserklärung zu Kontaktzwecken (optional)</b>
                    </div>
                    <div class="form-group">
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="checkbox" id="eweKontakt" name="eweKontakt" v-model="store.eweKontakt">
                            <label class="form-check-label" for="eweKontakt">
                                Ich willige ein, dass mich die <em><b>vigo</b></em> Krankenversicherung und ihre Vermittler telefonisch und per E-Mail über Versicherungsprodukte informieren dürfen. Dies gilt unabhängig davon, ob ein Vertrag besteht. Ein Widerruf für die Zukunft ist jederzeit möglich. 
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="mt-4 w-100 d-flex justify-content-end">
                <OnlineZahlungspflichtigAbschliessenButton 
                    data-shake="true"
                    :disabled="submitDisabled"
                    :isLoading="vertragStore.isSubmitting"
                    @click="handleAbschliessen"
                />
            </div>
        </div>
    </div>

    
  </form>
</template>

<script setup>
import { onMounted, computed, nextTick, ref } from 'vue';
import { formValidation } from '@form-validation/bundle/popular';
import { Bootstrap5 } from '@form-validation/plugin-bootstrap5';
import { Trigger } from '@form-validation/plugin-trigger';
import { useRechnerStore } from '@/stores/rechner';
import { useMainStore } from '@/stores/useMainStore.js';
import { useVertragStore } from '@/stores/vertrag.js';
import { useAntragStore } from '@/stores/antrag.js';
import { createVertrag, downloadVersicherungsschein } from '@/api/VertragService.js';
import SchritteZaehler from '@/components/general/schritte_zaehler.vue';
import OnlineZahlungspflichtigAbschliessenButton from '@/components/online_zahlungspflichtig_abschliessen_button.vue';


const store = useRechnerStore();
const mainStore = useMainStore();
const vertragStore = useVertragStore();
const antragStore = useAntragStore();

let fv = null;

// Computed für Button-States
const submitDisabled = computed(() => {
  return vertragStore.hasSubmit || vertragStore.isSubmitting;
});

const shouldShowRdnummerInfo = computed(() => {
  // Nur anzeigen wenn Feature enabled UND RD-Nummer vorhanden (nicht 0)
  return mainStore.aokEnabled && store.aok !== 0
});

const ewe1LabelText = computed(() => {
  if (mainStore.kanal === 'meinevigo') {
    return 'Einwilligung in Erhebung und Verwendung von Gesundheitsdaten sowie Schweigepflichtentbindungserklärung, außerdem weitere zusätzliche Erklärungen (siehe PDF-Dokument Vertragsgrundlagen und Erklärungen).';
  }
  return 'Einwilligung in Erhebung und Verwendung von Gesundheitsdaten, Sozialdaten der AOK Rheinland/Hamburg sowie Schweigepflichtentbindungserklärung, außerdem weitere zusätzliche Erklärungen (siehe PDF-Dokument Vertragsgrundlagen und Erklärungen).';
});

// Submit-Handler
const handleAbschliessen = async () => {
  console.log('[Schritt4Endkunde] handleAbschliessen wird aufgerufen');
  
  if (!fv) {
    console.error('[Schritt4Endkunde] FormValidation nicht initialisiert!');
    return;
  }
  
  const button = document.querySelector('[data-shake="true"]');
  console.log('[Schritt4Endkunde] Button gefunden:', !!button);
  
  // Validierung prüfen
  console.log('[Schritt4Endkunde] Starte Validierung...');
  const status = await fv.validate();
  console.log('[Schritt4Endkunde] Validierungsstatus:', status);
  
  if (status !== 'Valid') {
    // Validation failed - shake button
    console.log('[Schritt4Endkunde] Validierung fehlgeschlagen - Shake-Animation');
    if (button) {
      button.classList.add('shake');
      setTimeout(() => button.classList.remove('shake'), 500);
    }
    nextTick(() => {
      const firstInvalid = document.querySelector('#schritt4form .is-invalid');
      if (firstInvalid) {
        firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
    return;
  }
  
  // Validation erfolgt - API-Call starten
  console.log('[Schritt4Endkunde] Vertragsabschluss wird gestartet...');
  
  // Loading-State aktivieren
  vertragStore.isSubmitting = true;
  vertragStore.resetError();
  
  try {
    // API-Call: Vertrag anlegen
    const result = await createVertrag(antragStore.antragId);
    
    if (!result.success) {
      // Fehler beim Anlegen des Vertrags
      console.error('[Schritt4Endkunde] Fehler beim Vertrag:', result.error);
      vertragStore.errorMessage = result.error;
      vertragStore.isSubmitting = false;
      // Navigation zu Schritt5 mit Fehleranzeige
       store.resetVertragsdokumentDownloadStatus();
       store.stepStatus = 5;
      return;
    }
    
    // Erfolg - Speichere Daten im RechnerStore
    console.log('[Schritt4Endkunde] Vertrag erfolgreich angelegt');
    store.vertragsnummer = result.vertragsnummer;
    store.secretstring = result.secret;
    store.antragAbgeschickt = true;
    
    // Auch im VertragStore speichern
    vertragStore.vertragsnummer = result.vertragsnummer;
    vertragStore.secretstring = result.secret;
    vertragStore.hasSubmit = true;
    
    console.log('[Schritt4Endkunde] Warte 5 Sekunden vor Versicherungsschein-Download...');
    
    // 5 Sekunden warten (analog zur alten Implementierung)
    await new Promise(resolve => setTimeout(resolve, 5000));
    
    // Automatischer Download des Versicherungsscheins
    console.log('[Schritt4Endkunde] Starte Versicherungsschein-Download...');
    const downloadResult = await downloadVersicherungsschein(result.vertragsnummer, result.secret);
    
    if (!downloadResult.success) {
      console.error('[Schritt4Endkunde] Versicherungsschein-Download fehlgeschlagen:', downloadResult.error);
      // Fehler wird geloggt, aber wir navigieren trotzdem weiter
      // Der User kann auf der Erfolgsseite erneut herunterladen
    }
    
    // Navigation zu Erfolgsseite
    vertragStore.isSubmitting = false;
    
       store.resetVertragsdokumentDownloadStatus();
       store.stepStatus = 5;
    
  } catch (error) {
    console.error('[Schritt4Endkunde] Unerwarteter Fehler:', error);
    vertragStore.errorMessage = error.message || 'Ein unerwarteter Fehler ist aufgetreten';
    vertragStore.isSubmitting = false;
    // Navigation zu Schritt5 mit Fehleranzeige
       store.resetVertragsdokumentDownloadStatus();
       store.stepStatus = 5;
  }
};

// FormValidation initialisieren
onMounted(async () => {
    await nextTick()
    
    console.log('[Schritt4Endkunde] onMounted wird ausgeführt');
    console.log('[Schritt4Endkunde] store.aok:', store.aok);
    console.log('[Schritt4Endkunde] antragStore.antragId:', antragStore.antragId);
    
    const formElement = document.getElementById('schritt4form');
    
    if (!formElement) {
        console.error('[Schritt4Endkunde] Form-Element nicht gefunden!');
        return;
    }
    
    console.log('[Schritt4Endkunde] Form-Element gefunden');
    
    const fields = {
      ewe4: {
        validators: {
          choice: {
            message: 'Bitte bestätigen Sie die Kenntnisnahme des gewählten Leistungsumfanges.',
            min: 1,
          },
        },
      },
      ewe1: {
        validators: {
          choice: {
            message: 'Bitte akzeptieren Sie die Einwilligungserklärung in die Datenverarbeitung und weitere Erklärungen.',
            min: 1,
          },
        },
      },
    };

    
    fv = formValidation(formElement, {
      locale: 'de_DE',
      fields,
      plugins: {
        bootstrap5: new Bootstrap5({
          rowSelector: '.form-group, .form-check, .form-check-inline'
        }),
        trigger: new Trigger({
          event: 'blur change',
        }),
      },
    });
    
    console.log('[Schritt4Endkunde] FormValidation initialisiert');
});
</script>

<style scoped>
    .introclaim {
        margin-bottom: 1.5rem;
    }
    .platziert {
        position: absolute;
        right:0;
        top:0;
        transform: translate(-20%,-50%);
    }


    .schritt-zaehler-position {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 90vw;
    }

    @media (min-width: 768px) {
    .schritt-zaehler-position {
        width: 80vw;
    }
    }

    @media (min-width: 992px) {
    .schritt-zaehler-position {
        width: 70vw;
    }
    }

    @media (min-width: 1200px) {
    .schritt-zaehler-position {
        width: 60vw;
    }
    }

    h3 {
        color: #000;
        font-family: "Source Sans Pro";
        font-size: 22px;
        font-style: normal;
        font-weight: 700;
        line-height: 160%;
        text-align: left;
    }

    @keyframes shake {
        0%, 100% { transform: translateX(0); }
        10%, 30%, 50%, 70%, 90% { transform: translateX(-5px); }
        20%, 40%, 60%, 80% { transform: translateX(5px); }
    }

    .shake {
        animation: shake 0.5s ease-in-out;
    }

    /* Initialer Rand für Pflicht-Checkboxen zur besseren Sichtbarkeit */
#schritt4form .form-check-input#ewe1:not(.is-invalid),
#schritt4form .form-check-input#ewe4:not(.is-invalid),
#schritt4form .form-check-input#eweKontakt:not(.is-invalid) {
  border: 2px solid var(--vigo-6-600-border);
}
</style>